/**
 *	Use ACFs to redirect homepage search based on keyword phrase to page associations
 */
var di_get_homepage_acf_redirect_url = function(search_term){
    if(typeof di_homepage_acf_redirects === 'undefined' || di_homepage_acf_redirects.length === 0)
        return false;

    var redirect_url = false;
    var redirects = jQuery.grep(di_homepage_acf_redirects,function(r){
        if(!r.terms || !r.redirect_url)
            return false;

        //find exact matches
        if(jQuery.inArray(search_term.toLowerCase(),r.terms) > -1)
            return true;

        //look for partial matches if wildcards are used i.e. %lease%
        var partial_match = false;
        jQuery.each(r.terms,function(i,term){
            if((term.match(/%/g)||[]).length === 2 && search_term.toLowerCase().indexOf( term.replace(/%/g,'') ) > -1)
            {
                partial_match = true;
                return false;
            }
        });
        return partial_match;
    });

    jQuery.each(redirects,function(i,r){
        if(r.redirect_url)
        {
            redirect_url = r.redirect_url;
            return false;
        }
    });
    return redirect_url;
};

/**
 *	Return VRP URL
 */
var di_get_search_redirect_url = function(type){
    var query = '#action=im_ajax_call&perform=get_results&page=1';
    var url = '';
    try
    {
        //Honda compliance - redirect all searches to new VRP
        if((di_search_settings.dealer_makes.indexOf("Honda") > -1 || di_search_settings.dealer_makes.indexOf("Acura") > -1)
            && (di_search_settings.new_on_used === '' || di_search_settings.used_on_new === ''))
            di_search_settings.used_vehicles_url = di_search_settings.new_vehicles_url;

        if(di_search_settings.new_vehicles_url === '' && di_search_settings.used_vehicles_url === '')
            throw "Please set New and Used pages in Site Configurations.";

        //when a hidden field is used and multiple types are set i.e. value="New,Used"
        if(type && typeof(type) === 'string' && type.indexOf(',') > -1)
            type = type.split(',');

        if(type && typeof(type) === 'object')//this is true if data-type attribute is set for the search field or multiple types are set using a hidden field
        {
            var len = jQuery.map(type, function(n, i) { return i; }).length;
            if(len === 1)
            {
                url = di_get_search_redirect_url(type[0]);
            }
            else
            {
                url = di_search_settings.used_vehicles_url + query;
                jQuery.each(type,function(i,v){ url += "&type%5B%5D="+encodeURIComponent(v); });
            }
        }
        else
        {
            switch(type)
            {
                case false:
                case '':
                    if (window.hasOwnProperty('homePageLightningSettings') && window.homePageLightningSettings.usedShouldBePreOwned == true) {
                        url = di_search_settings.used_vehicles_url + query + "&type%5B%5D=New&type%5B%5D=Pre-Owned&type%5B%5D=Certified Pre-Owned";
                    } else {
                        url = di_search_settings.used_vehicles_url + query + "&type%5B%5D=New&type%5B%5D=Used&type%5B%5D=Certified Used";
                    }
                    break;

                case 'New':
                    url = di_search_settings.new_vehicles_url !== '' ? di_search_settings.new_vehicles_url + query + "&type%5B%5D=New" : di_search_settings.used_vehicles_url + query + "&type%5B%5D=New";
                    break;
                case 'Used':
                    url = di_search_settings.used_vehicles_url + query + "&type%5B%5D=Used";
                    break;
                case 'Pre-Owned':
                    if (typeof(di_search_settings.include_cpo_when_used_selected) !== 'undefined' && di_search_settings.include_cpo_when_used_selected === 'enabled') {
                        url = di_search_settings.used_vehicles_url + query + "&type%5B%5D=Pre-Owned&type%5B%5D=Certified Pre-Owned";
                    } else {
                        url = di_search_settings.used_vehicles_url + query + "&type%5B%5D=Pre-Owned";
                    }
                    break;
                default:
                    url = di_search_settings.used_vehicles_url + query + "&type%5B%5D="+encodeURIComponent(type);

            }
        }

        if(url === '')
        {
            url = (di_search_settings.used_vehicles_url !== '' ? di_search_settings.used_vehicles_url : di_search_settings.new_vehicles_url) +  "#action=im_ajax_call&perform=get_results&page=1&type%5B%5D=New&type%5B%5D=Used&type%5B%5D=Certified Used";
        }
    }
    catch(e)
    {
        if(typeof(console) !== 'undefined')
            console.log(e);

        return false;
    }

    return url;

};

var update_filters = function($container,reset){
    var $ = jQuery;
    var vehicles = (JSON.parse(JSON.stringify(di_search_settings.filters)));
    var container_filters = [];
    try
    {
        //var available_filters = $container.find(':input[type=hidden],:input[type=radio]:selected,select').not("button,[type=submit],[type=text]");
        var available_filters = $container.find(':input,select').not("button,[type=submit],[type=text], .vehicle-geoRadius, .overrideDynamicFilter");
        if(available_filters.length === 0)
            throw "No filters were found in container!";
        $.each(available_filters,function(index,filter){
            var key = $(filter).attr('name') ? $(filter).attr('name').replace('[]','').replace(/s$/i,'') : null;
            var val = $(filter).val() ? $(filter).val().toString() : null;
            var order = $(filter).data('order') ? $(filter).data('order') : null;
            var input_type = this.type;
            if(key === null)
                return;
            switch(key)
            {
                case "mile":
                    key = 'miles';
                    order = order === null ? 'range' : order;
                    break;
                case "our_price":
                case "price":
                    order = order === null ? 'range' : order;
                    break;
                case "type":
                    order = order === null ? 'vehicle-condition' : order;
                    if(filter.type === 'radio')
                    {
                        val = $container.find(':input[type=radio][name="type[]"]:checked').val();
                        if(val)
                            break;
                        if(di_search_settings.new_on_used === '' || di_search_settings.used_on_new === '')
                        {
                            if(!$(filter).val())
                            {
                                $(filter).parent('.radio-button').remove();
                                return;
                            }
                        }
                        if(!val && $container.find(':input[type=radio][name="type[]"]:checked').length === 0)
                        {
                            $(filter).attr('checked','checked');
                            val = $(filter).val();
                        }
                        if(!val)
                            return;
                    }
                    break;
                case "year":
                    order = order === null ? 'desc' : order;
                    break;
            }
            if(order === null)
                order = 'asc';
            if(reset === true && (key !== 'type' && input_type !== 'hidden'))
                val = null;
            container_filters.push({'key':key,'selected_value':val,values:[],'order':order,'element':$(filter),'input_type': input_type});
        });
        if(container_filters.length === 0)
            throw "Could not detect filters in container!";
        if(window['search_filters_object'])
            vehicles = search_filters_object(vehicles,container_filters);
        $.each(container_filters,function(index,filter){
            var selected_value = filter.selected_value;
            var current_key = filter.key;
            $.each(vehicles,function(uid,vehicle){
                if(typeof(vehicle[current_key]) === 'undefined'/* || (selected_value !== null && vehicle[current_key] !== selected_value)*/)
                    return;
                var skip = false;
                var value = vehicle[current_key];
                if(!value)
                    return;
                $.each(container_filters,function(fi,_filter){
                    if(_filter.selected_value === null || _filter.key === current_key)
                        return;
                    var _key = _filter.key;
                    //console.log(_key + " => " + vehicle[_key]);
                    if(typeof(vehicle[_key]) === 'undefined')
                    {
                        skip = true;
                        return true;
                    }
                    //FD #25261 - include CPO vehicles when Pre-Owned is selected
                    if(_key === 'type' && typeof(di_search_settings.include_cpo_when_used_selected) !== 'undefined' && di_search_settings.include_cpo_when_used_selected === 'enabled' && _filter.selected_value === 'Used' && vehicle[_key] === 'Certified Used')
                    {
                        vehicle[_key] = 'Used';
                    }
                    if(_filter.selected_value !== null)
                    {
                        //allow passing multiple values in hidden fields i.e. <input type="hidden" name="make[]" value="Toyota,Scion" />
                        if(_filter.input_type === 'hidden' && _filter.selected_value.search(',') > -1)
                        {
                            if(_filter.selected_value.search(vehicle[_key]) === -1)
                            {
                                skip = true;
                                return true;
                            }
                        }
                        else if(_filter.selected_value !== vehicle[_key])
                        {
                            skip = true;
                            return true;
                        }
                    }
                });
                if(skip === false && $.inArray(value,container_filters[index].values) === -1)
                    container_filters[index].values.push(value);
            });
        });
        $container.find("select").not(".overrideDynamicFilter, .noFilter").find("option").each(function(index, element) {
            if($(element).val() !== '')
                $(element).remove();
        });
        var filterValues = [];
        if (window.inventoryLightningFilterHomePageFilters) {
            container_filters = window.inventoryLightningFilterHomePageFilters(container_filters);
        }
        $.each(container_filters,function(index,filter){
            if(filter.values.length === 0)
                return;
            switch(filter.order)
            {
                case "asc":
                    filter.values.sort();
                    break;
                case "desc":
                    filter.values.sort().reverse();
                    break;
                case "range":
                    filter.values = searchSortArray(filter.values);
                    break;
                case "vehicle-condition":
                    break;
            }
            $.each(filter.values,function(i,v){
                filterValues.push( v );
                if(typeof(filter.element) === 'object')
                {
                    if(filter.element.is("select") === true)
                    {
                        var text = filter.key === 'type' ? v.replace('Used','Pre-Owned') : v;
                        // 8-31-16: translate text based on current language. Returns English if no secondary languages are detected
                        text = translateType( text );
                        if (filter.order === 'range')
                        {
                            text = DealerInspireInventory.format.number(text).replace('-', ' - ');
                        }
                        filter.element.append("<option value='"+v+"' "+(filter.selected_value !== null && v === filter.selected_value ? "selected='selected'" : '')+">"+text+"</option>");
                    }
                }
            });
        });
        $("body").trigger('search_filters_rendered', [filterValues]);
    }
    catch(e)
    {
        if(typeof(console) !== 'undefined')
            console.log(e.stack);
    }
}


var hasOnlyNewVehicles = function(search_params){

    var filters = di_search_settings.filters,
        inRow;

    if (Object.keys(search_params).length === 0) {
        return false;
    }

    if (search_params.hasOwnProperty('type')) {
        return (search_params['type'].value === 'New') ? true : false;
    }

    /**
     * Loop through vehicles to see if Only New Vehicles Exist
     */
    for (var i = 0 ; i < filters.length ; i++) {

        if (filters[i]["type"] !== 'New') {
            inRow = 1; // assume the vehicle contains the searched items

            //loop through selected filters, see the values match.  IF not, set inRow = 0;
            for (var k in search_params) {
                if (search_params[k].value !== filters[i][k]) {
                    inRow = 0;
                    break;
                }
            }

            // If the row contains the searched for criteria and the type does equal new, return false
            if (inRow === 1) {
                return false;
            }
        }
    }

    return true;
}

/**
 * WPML Only ( we added a non-english class to languages that are not english to make sure this isn't running every time )
 * Translate search filter option TEXT ( not values ) with translations located in .PO file in inventory plugin
 */
if( jQuery( 'body.non-english' ).length )
{
    jQuery("body").on('search_filters_rendered', function(e,filterVals){

        if(typeof di_search_settings.translated_values === "undefined")
        {
            di_search_settings.translated_values = {};

            jQuery.ajax({
                url: '/',
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'im_ajax_call',
                    perform: "translate_search_filters", // located in language_functions.php
                    filterVals: filterVals,
                    _language_code: typeof icl_vars === 'object' && icl_vars.current_language !== 'en' ? icl_vars.current_language : ''
                }
            }).done( function( data ){

                if(typeof data !== 'object')
                {
                    data = window.JSON.parse(data);
                }

                di_search_settings.translated_values = data;

                jQuery("body").trigger('search_filters_rendered',[filterVals]);

            });
        }

        if(typeof di_search_settings.translated_values === "object")
        {

            jQuery.each( di_search_settings.translated_values, function( k,v ){

                var $options = jQuery('.filters-container option[value="'+k+'"]' );

                if( $options.length ) {

                    if(k.search(/pre-owned|new|used/i) > -1)
                    {
                        v = translateType(k);
                    }

                    $options.text( v );
                }

            });

        }

    });
}

/**
 * Translate Type dropdown to French or Spanish
 * @param  string text 		The text to translate
 * @return string      		either translated text if current site is in secondary language mode or original text if not
 */
function translateType( text )
{
    var is_fr = ( jQuery( 'body.lang-french' ).length ) ? true : false;
    var is_es = ( jQuery( 'body.lang-spanish' ).length ) ? true : false;

    if( !is_fr && !is_es )
        return text;

    switch( text )
    {
        case "New":
            text = ( is_fr ) ? 'Neuf' : 'Nuevo';
            break;

        case "Used":
        case "Pre-Owned":
            text = ( is_fr ) ? 'd’occasion' : 'Usado';
            break;

        case "Certified Used":
        case "Certified Pre-Owned":
            text = ( is_fr ) ? 'd’occasion Certifiés' : 'Usado Certificado';
            break;
    }

    return text;

}

var searchSortArray = function(arr) {
    var tempArr = [], n;
    for (var i in arr) {
        tempArr[i] = arr[i].match(/([^0-9]+)|([0-9]+)/g);
        for (var j in tempArr[i]) {
            if( ! isNaN(n = parseInt(tempArr[i][j])) ){
                tempArr[i][j] = n;
            }
        }
    }
    tempArr.sort(function (x, y) {
        for (var i in x) {
            if (y.length < i || x[i] < y[i]) {
                return -1; // x is longer
            }
            if (x[i] > y[i]) {
                return 1;
            }
        }
        return 0;
    });
    for (var i in tempArr) {
        arr[i] = tempArr[i].join('');
    }
    return arr;
};

jQuery(document).ready(function($){
    /**
     *	If geoZip is added, update URL structure to have _geoZip and _geoRadius
     *  _geoZip requires _geoRaius. If _geoRadius is not provided as a select option, default to all.
     */
    var di_get_geoZip = function(url){
        var geoZipVal = $('.geo-zipcode-input-filter').map(function() {
            return this.value || null;
        }).get();
        // Check to see if geoRadius is added and grab the value of the select.
        if( $('.filters-container select').hasClass('vehicle-geoRadius') ){
            var geoRadiusVal = $('.filters-container .vehicle-geoRadius').map(function() {
                return parseInt(this.value) || null;
            }).get();
        }

        // Check if .geo-zipcode-input is a class
        if( $('input[type=number]').hasClass('geo-zipcode-input-filter'))
        {
            // Stripping out the default all selection so if there are two searches on the page only the selected radius number is returned
            function numbersOnly(value) {
                if (typeof (value) === 'number') {
                    return value;
                }
            }
            geoRadiusVal.filter(numbersOnly);

            // Adding the all back in if no radius number was selected
            if ((geoRadiusVal.length === 0)||(geoRadiusVal === ""))
            {
                geoRadiusVal = "all";
            }
            // if you have no value for zip, return false and have them add a value into radius
            if((geoZipVal.length === 0) && (geoRadiusVal !== "all") ) {
                alert('Please enter a zipcode');
                return false;
            }
            // Split url into two
            var splitURL = url.split('#');
            // Inserting query string before inventory hash to pass to LVRP
            var newURL = splitURL[0] + "?_geoZip=" + geoZipVal + "&_geoRadius=" + geoRadiusVal + "#" + splitURL[1];
        }
        return newURL;
    };

    if($(".filters-container").length > 0)
    {
        if(typeof di_search_settings.filters === 'undefined')
        {
            jQuery.ajax({
                url: di_search_settings.ajax_url,
                type: 'post',
                dataType: 'json',
                data: {action: 'im_ajax_call', perform: 'homepage_search_filters'},
                success: function(filters)
                {
                    di_search_settings.filters = filters;
                    $(".filters-container").each(function(index, element) {
                        var that = this;
                        update_filters($(that));
                        $(that).find(":input").change(function(e) {
                            var reset = $(this).attr('name') === 'type[]';
                            update_filters($(that),reset);
                        });

                        $(that).find("input[type=button],button:not(.selectpicker),submit").click(function(e){
                            var $search_field = DealerInspireSearchAnything.get_instance($(that).find("#search-anything-field,.alg-searc-class"));
                            var keyword = '';
                            if(typeof($search_field.element) !== 'undefined')
                                keyword = $search_field.element.val();

                            var placeholder_text = $search_field.placeholder_text ? $search_field.placeholder_text : di_search_settings.placeholder_text;

                            var selected_filters = [];
                            try
                            {
                                var available_filters = $(that).find(':input,select').not("button,[type=submit],[type=text]");
                                if(available_filters.length === 0 && !keyword)
                                    throw "Nothing to search for!";

                                $.each(available_filters,function(index,filter){
                                    var url_key = $(filter).attr('name') ? $(filter).attr('name') : null;
                                    if(url_key)
                                    {
                                        //change plural keys to singular i.e. makes[] => make[]
                                        jQuery.each([['years','year'],['makes','make'],['models','model']],function(i,a){
                                            url_key = url_key.replace(a[0],a[1]);
                                        });
                                    }
                                    var key = $(filter).attr('name') ? $(filter).attr('name').replace('[]','').replace(/s$/i,'') : null;
                                    var val = $(filter).val() ? $(filter).val().toString() : null;
                                    if(filter.type === 'radio' && $(filter).is(":checked") === false)
                                        return;

                                    if(!key || !val)
                                        return;

                                    selected_filters[key] = {'value':val,'url_key':url_key};
                                });

                                var url = '';
                                if(typeof(selected_filters['type']) !== 'undefined' && (!keyword || keyword == '' || keyword == placeholder_text)) {
                                    url = di_get_search_redirect_url(selected_filters['type']['value']);
                                }
                                else {
                                    url = hasOnlyNewVehicles(selected_filters) ? di_get_search_redirect_url('New') : di_get_search_redirect_url(false);
                                }

                                if(keyword && keyword !== placeholder_text)
                                {
                                    if($search_field.redirect_url !== false)
                                    {
                                        url = $search_field.redirect_url;
                                        $search_field.element.val('Loading...').attr('disabled','disabled');
                                    }
                                    else
                                    {
                                        if(keyword.search(/new /i) !== -1)
                                            $search_field.type = 'New';
                                        else if(keyword.search(/used |pre-owned |preowned /i) !== -1)
                                            $search_field.type = 'Used';
                                        else if(keyword.search(/cpo |certified /i) !== -1)
                                            $search_field.type = 'Certified Used';

                                        if($search_field.type)
                                            url = di_get_search_redirect_url($search_field.type);
                                        else if(typeof(selected_filters['type']) !== 'undefined')
                                            url = di_get_search_redirect_url(selected_filters['type']['value']);

                                        if(url === false)
                                            return false;

                                        if(DealerInspireBrowserDetection.isFireFox() === true && keyword.search('&') > -1)
                                            filter.value = filter.value.replace(/&/g,'_AND_');

                                        url += "&search="+keyword;
                                    }

                                    if((acf_redirect_url = di_get_homepage_acf_redirect_url(keyword)) !== false)
                                        url = acf_redirect_url;

                                }
                                else
                                {
                                    if(url === false)
                                    {
                                        throw "Redirect URL is not set!";
                                    }

                                    for(var key in selected_filters)
                                    {
                                        var filter = selected_filters[key];
                                        if(key === 'type' || !filter.value)
                                            continue;

                                        if(DealerInspireBrowserDetection.isFireFox() === true && filter.value.search('&') > -1)
                                            filter.value = filter.value.replace('&','_AND_');

                                        if(filter.value.search(',') > -1)
                                        {
                                            jQuery.each(filter.value.split(','),function(i,v){
                                                url += "&"+encodeURIComponent(filter.url_key) + "=" +encodeURIComponent(v);
                                            });
                                        }
                                        else
                                        {
                                            url += "&"+encodeURIComponent(filter.url_key) + "=" +encodeURIComponent(filter.value);
                                        }
                                    }
                                }

                                // If geo-zipcode-input-filter is being added for Geolocation Filtering
                                if( $('input[type=number]').hasClass('geo-zipcode-input-filter')){
                                    if(url){
                                        url = di_get_geoZip(url);
                                    }
                                }

                                if(window['search_filters_redirect_url'])
                                    url = search_filters_redirect_url(url,selected_filters,$search_field);

                                if(url === false)
                                    return false;

                                window.location.href = url;
                                return false;

                            }
                            catch(e)
                            {
                                if(typeof(console) !== 'undefined')
                                    console.log(e);

                                return false;
                            }
                        });

                    });
                }
            });
        }
    }
});
